<template>
  <router-link :to="to">{{ text }}</router-link>
</template>

<script>
export default {
  props: {
    to: String,
    text: String
  }
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: #595959;
  font-weight: bold;
  position: relative;
  font-size: 18px;

  &.router-link-active,
  &:hover {
    color: #0091d5;
    &:before,
    &:after {
      content: "";
      display: block;
      width: 16px;
      height: 16px;
      position: absolute;
    }

    &:before {
      top: -15px;
      left: -15px;
      background: url("../assets/about-us-active-link-top-left.svg") no-repeat;
    }

    &:after {
      bottom: -15px;
      right: -15px;
      background: url("../assets/about-us-active-link-bottom-right.svg")
        no-repeat;
    }
  }
}

@media (max-width: 1023px) {
  a {
    font-size: 12px !important;
  }
}
</style>
